import { render, staticRenderFns } from "./MentalStatus.vue?vue&type=template&id=ee0a1bca&"
import script from "./MentalStatus.vue?vue&type=script&lang=js&"
export * from "./MentalStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports